import { useCallback } from 'react';
import { Query } from '@/utils/react-query/Queries';
import useOrganizationEntitlements from '@/utils/hooks/useOrganizationEntitlements';
import { canAccessScreen } from '@/utils/shortcutPermissions';

/**
 * Predicate for whether the logged-in user may access a shortcut screen.
 * Bundles user + entitlements + small group types (for typeID role gating)
 * + organization (for feature-flagged modules like Bible Studies) so call
 * sites just do `canAccess('/tasks/create')`.
 */
const useShortcutAccess = () => {
    const { data: loggedInUser } = Query.people.loggedInUser();
    const { entitlements } = useOrganizationEntitlements();
    const { data: smallGroupTypes = [] } = Query.smallGroupTypes.all({});
    const { data: organization } = Query.organization.byId({
        id: loggedInUser?.organizationID,
        options: { enabled: !!loggedInUser?.organizationID },
    });

    return useCallback(
        (screen) => canAccessScreen(screen, loggedInUser, entitlements, smallGroupTypes, organization),
        [loggedInUser, entitlements, smallGroupTypes, organization]
    );
};

export default useShortcutAccess;
